import { GridCellProps } from '@progress/kendo-react-grid';
import { useMemo } from 'react';
import GridCellBase from 'src/components/GridCellBase';
import NumberInput from 'src/components/NumberInput';
import { GridContext, GridContextValue } from 'src/contexts/GridContext';
import useDelayedInputOnchange from 'src/hooks/useDelayedInputOnchange';
import { isNullOrUndefined } from 'src/utils';
import { round } from 'src/utils/number';
import { useContextSelector } from 'use-context-selector';

const QuantityCell = (props: GridCellProps) => {
  const { data } = useContextSelector(GridContext, (context) => context as GridContextValue);
  const { handleChange, value } = useDelayedInputOnchange(props);
  const { dataItem } = props;
  const uomDataItem = data?.find((item) => item.field === 'uom');
  const isLb = useMemo(
    () => String(uomDataItem?.value).toLowerCase() === 'lb',
    [uomDataItem?.value]
  );
  const newValue = round(Number(value), isLb ? 3 : 2);
  const title = '$' + newValue;
  const isDisabled = !dataItem.selected;

  return (
    <GridCellBase {...props} className={'!bg-transparent'} title={title}>
      <div className="flex items-center gap-2">
        <span className="text-black">=</span>
        <NumberInput
          value={isNullOrUndefined(value) ? '' : newValue.toString()}
          onChange={handleChange}
          prefix="$"
          decimal={isLb ? 3 : 2}
          disabled={isDisabled}
          width="100%"
        />
      </div>
    </GridCellBase>
  );
};

export default QuantityCell;
